(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var body = document.body;

  function setLocked(isLocked) {
    body.classList.toggle('is-locked', isLocked);
  }

  function initDisclosure(triggerSelector, panelSelector, openClass) {
    var trigger = document.querySelector(triggerSelector);
    var panel = document.querySelector(panelSelector);
    if (!trigger || !panel) return;

    function close() {
      panel.classList.remove(openClass);
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      setLocked(false);
    }

    function open() {
      panel.classList.add(openClass);
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      setLocked(true);
      var firstFocusable = panel.querySelector(focusableSelector);
      if (firstFocusable) firstFocusable.focus({ preventScroll: true });
    }

    trigger.addEventListener('click', function () {
      panel.classList.contains(openClass) ? close() : open();
    });

    panel.addEventListener('click', function (event) {
      if (event.target.closest('[data-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains(openClass)) close();
    });
  }

  function initHeader() {
    initDisclosure('[data-mobile-menu-open]', '[data-mobile-drawer]', 'is-open');
    initDisclosure('[data-search-open]', '[data-search-popover]', 'is-open');

    document.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('[data-mega-trigger]').forEach(function (item) {
          item.setAttribute('aria-expanded', 'false');
        });
        trigger.setAttribute('aria-expanded', String(!expanded));
        event.preventDefault();
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.site-nav__item')) {
        document.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function initSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      var previous = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      if (!track || !previous || !next) return;

      function scroll(direction) {
        var amount = Math.max(track.clientWidth * 0.85, 280);
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      previous.addEventListener('click', function () {
        scroll(-1);
      });

      next.addEventListener('click', function () {
        scroll(1);
      });
    });
  }

  function initLightbox() {
    var triggers = document.querySelectorAll('[data-lightbox-src]');
    if (!triggers.length) return;

    var lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Galería de proyecto');
    lightbox.innerHTML = '<div class="lightbox__panel"><button class="icon-button lightbox__close" type="button" data-lightbox-close aria-label="Cerrar"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg></button><img class="lightbox__image" alt=""></div>';
    document.body.appendChild(lightbox);

    var image = lightbox.querySelector('.lightbox__image');
    var closeButton = lightbox.querySelector('[data-lightbox-close]');

    function close() {
      lightbox.classList.remove('is-open');
      setLocked(false);
      image.removeAttribute('src');
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        image.src = trigger.getAttribute('data-lightbox-src');
        image.alt = trigger.getAttribute('data-lightbox-alt') || '';
        lightbox.classList.add('is-open');
        setLocked(true);
        closeButton.focus({ preventScroll: true });
      });
    });

    closeButton.addEventListener('click', close);
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) close();
    });
  }

  function initReveal() {
    var elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var mainImage = gallery.querySelector('[data-product-main-image]');
      if (!mainImage) return;

      gallery.querySelectorAll('[data-product-thumb]').forEach(function (button) {
        button.addEventListener('click', function () {
          mainImage.src = button.getAttribute('data-src');
          mainImage.alt = button.getAttribute('data-alt') || mainImage.alt;
        });
      });
    });
  }

  function getFieldValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : '';
  }

  function initQuoteMailto() {
    document.querySelectorAll('.quote-form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var destination = (getFieldValue(form, 'contact[Correo destino]') || 'ventas@cubiertasrs.cl').replace(/\s/g, '');
        var name = getFieldValue(form, 'contact[name]');
        var email = getFieldValue(form, 'contact[email]');
        var phone = getFieldValue(form, 'contact[phone]');
        var comuna = getFieldValue(form, 'contact[comuna]');
        var ciudad = getFieldValue(form, 'contact[ciudad]');
        var quantity = getFieldValue(form, 'contact[cantidad_de_planchas]');
        var lengths = getFieldValue(form, 'contact[largos]');
        var color = getFieldValue(form, 'contact[color]');
        var message = getFieldValue(form, 'contact[body]');

        if (!name || !email || !phone || !comuna || !ciudad || !message) return;

        event.preventDefault();

        var subject = 'Solicitud de cotización CubiertasRS';
        var bodyLines = [
          'Nombre: ' + name,
          'Correo: ' + email,
          'Teléfono: ' + phone,
          'Comuna: ' + comuna,
          'Ciudad: ' + ciudad,
          'Cantidad de planchas: ' + (quantity || 'No indicado'),
          'Largos: ' + (lengths || 'No indicado'),
          'Color: ' + (color || 'No indicado'),
          '',
          'Mensaje:',
          message
        ];

        window.location.href = 'mailto:' + destination + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(bodyLines.join('\n'));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initSliders();
    initLightbox();
    initReveal();
    initProductGallery();
    initQuoteMailto();
  });
})();
